<template>
    <div class="exam_paper">
        <div class="exam_content flex Flexalign Flexjustify">
            <div class="exam_content_box mt-30 flex FlexBetween">
                <div class="test_paper_practice">
                    <div class="flex Flexalign cursor_pointer back_box" @click="practiceBack">
                        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
                        <div class="back_text">返回</div>
                    </div>
                    <recordTestPaper :examInfo="examInfo" :hideCountDown="true" @refreshTextExam="refreshTextExam"
                        :hideBack="true">
                    </recordTestPaper>
                </div>
                <examAnswerSheet ref="examAnswerSheet" @refreshTextExam="refreshTextExam" :showCourseOutline="false"
                    :examType="'record'" :homeworkType="'afterHomework'" :hideCountDown="true"></examAnswerSheet>
            </div>
        </div>
    </div>
</template>

<script>
import recordTestPaper from './components/recordTestPaper.vue';
import examAnswerSheet from '@/components/exam/examAnswerSheet.vue';
export default {
    name: 'GjkcH5ExamRecordPaper',
    components: { recordTestPaper, examAnswerSheet },

    data() {
        return {
            recordId: '',
            examInfo: {},
            testPaperType: ''
        };
    },

    mounted() {
        this.recordId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).recordId;
        this.testPaperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).testPaperType;
        if (this.testPaperType == 'testPaper') {
            this.getTestPaperRecord();
        } else if (this.testPaperType == 'examination') {
            this.getExaminationPaperRecord();
        } else {
            this.getNewExamRecordInfo();
        }
    },

    methods: {
        practiceBack() {
            if (this.testPaperType == 'examination') {
                this.$Jump.go(-2);
            } else {
                this.$Jump.go(-1);
            }
        },
        getNewExamRecordInfo() {
            this.$Api.exam.getNewExamRecordInfo(this.recordId).then(res => {
                this.examInfo = res.data.data;
            }).catch(() => { })
        },
        // 测评作答记录
        getTestPaperRecord() {
            this.$Api.testPaper.getTestPaperRecord(this.recordId).then(res => {
                this.examInfo = res.data.data;
            }).catch(() => { })
        },
        // 试卷中心作答记录
        getExaminationPaperRecord() {
            this.$Api.examination.getExaminationRecordPaper(this.recordId).then(res => {
                this.examInfo = res.data.data;
            }).catch(() => { })
        },
        // 刷新测试组件
        refreshTextExam() {
            this.refreshKey += 1;
        }
    },
};
</script>

<style lang="scss" scoped>
.exam_paper {
    width: 100%;
    min-height: 100vh;
    background: rgba(0, 0, 0, 0.06);

    .back_box {
        justify-content: flex-end;
    }

    .back_icon {
        width: 28px;
        height: 28px;
    }

    .back_text {
        font-size: 14px;
        color: #13d6aa;
        margin-left: 7px;
    }

    .exam_content {
        .exam_content_box {
            width: $pageMainWidth;
        }

        .test_paper_practice {
            width: 850px;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
            border-radius: 10px;
        }
    }
}
</style>